import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TopicsPage from "../pages/topics/page";
import ArticlePage from "../pages/article/page";
import TimelinePage from "../pages/timeline/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/topics",
    element: <TopicsPage />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/timeline",
    element: <TimelinePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;